var _g, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512.001 512.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#41479b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 155.366H0V97.104a8.829 8.829 0 0 1 8.828-8.828h494.345a8.829 8.829 0 0 1 8.828 8.828L512 155.366zM503.172 423.724H8.828A8.829 8.829 0 0 1 0 414.896v-58.262h512v58.262a8.828 8.828 0 0 1-8.828 8.828z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 155.37h512v67.09H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#41479b",
    d: "M0 222.46h512v67.09H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f5f5f5",
    d: "M0 289.55h512v67.09H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.31 421.628l255.402-161.754c2.841-1.8 2.841-5.945 0-7.745L3.31 90.373C1.335 91.992 0 94.351 0 97.104v317.792c0 2.753 1.336 5.112 3.31 6.732z",
    fill: "#ff4b55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.526 213.441l9.064 27.176 28.647.222c2.219.018 3.139 2.849 1.354 4.168l-23.045 17.018 8.641 27.313c.67 2.116-1.74 3.866-3.545 2.575l-23.306-16.658-23.306 16.659c-1.805 1.291-4.215-.46-3.545-2.575l8.641-27.312-23.046-17.018c-1.785-1.319-.865-4.151 1.354-4.168l28.647-.222 9.064-27.176c.701-2.107 3.679-2.107 4.381-.002z",
    fill: "#f5f5f5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCu);
export default __webpack_public_path__ + "static/media/cu.46c08bb89aa3c2b8d6dd87919c66e89f.svg";
export { ForwardRef as ReactComponent };